export default "__VITE_ASSET__jhtJWAmm__"